// extracted by mini-css-extract-plugin
export default {"container":"AuditDashboardTab_container_KpDJC","spinAround":"AuditDashboardTab_spinAround_FyPRe"};